import dayjs from 'dayjs';
import orderby from 'lodash.orderby';
import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
  },
  state: {
    live_news: [
      {
        id    : 1,
        date  : 1543093200000,
        author: {
          id    : 1,
          name  : 'OlegAfanasiev',
          avatar: '/images/avt-40-1.png',
        },
        text: 'Усовершенствован раздел «База знаний» на портале. Теперь можно скачивать материалы прямо на рабочий компьютер, телефон или планшет. Для регистрации на портале необходимо запросить логин/пароль у своего…',
      },
    ],
    selected_number: 10,
    selected_page  : 1,
  },
  getters: {
    live_news       : ({live_news}) => live_news,
    selected_number : ({selected_number}) => selected_number,
    selected_page   : ({selected_page}) => selected_page,
    search_live_news: ({live_news}, {}, rootState)=> {
      let search_string = rootState.activity.search_string;
      if (search_string) {
        return live_news.filter((x)=> x.message.toLowerCase().includes(search_string.toLowerCase()));
      } else return live_news;
    },
    paginated({live_news, selected_number, selected_page}, {search_live_news}, rootState) {
      let search_string = rootState.activity.search_string;
      let search_filtered = search_string ? search_live_news : live_news;
      return search_filtered.slice((selected_number*(selected_page-1)), selected_number*selected_page);
    },
  },
  mutations: {
    SET_ACTIVITY_FEED(state, value) {
      state.live_news = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    CLEAR_FEED_PAGES(state) {
      state.selected_page = 1;
    },
    // SEARCH_STRING(state, value) {
    //   state.search_string = value;
    //   state.selected_page = 1;
    // },

  },
  actions: {
    show_number({commit, getters}, event) {
      const {filtered_by_theme} = getters;
      commit('CLEAR_FEED_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_theme, selected: event});
    },
  },
};
